import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core.module';
import { RouterModule } from '@angular/router';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { ErrorCounterModule } from '@components/error-counter/error-counter.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    ErrorCounterModule
  ],
  declarations: [
    ToolbarComponent
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule { }
